import { render, staticRenderFns } from "./VtkProj.vue?vue&type=template&id=68c3061d&scoped=true"
import script from "./VtkProj.vue?vue&type=script&lang=js"
export * from "./VtkProj.vue?vue&type=script&lang=js"
import style0 from "./VtkProj.vue?vue&type=style&index=0&id=68c3061d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c3061d",
  null
  
)

export default component.exports